import { FaPhoneAlt } from "react-icons/fa";

export default function CallButton() {
  return (
    <div className="relative group">
      <a
        href="tel:+79166665339"
        className="flex items-center justify-center w-12 h-12 bg-second text-white rounded-full shadow-lg transition-transform transform hover:scale-110 hover:bg-blue-600 focus:outline-none"
      >
        <FaPhoneAlt size={20} />
      </a>

      {/* Пульсирующее кольцо анимации при наведении */}
      <span className="absolute inset-0 rounded-full border-2 border-second opacity-0 group-hover:opacity-100 animate-ping"></span>
    </div>
  );
}
